import React from 'react';
import { Stack } from '@mui/material';
import { FileListItem } from './FileListItem';
import { FileListStateShape } from '../hooks/useFileListState';

export const FileListLayout = ({ fileListState }) => (
  <Stack spacing={2} mt={2}>
    {fileListState.visibleFiles.map((file) => (
      <FileListItem key={file.id} file={file} fileListState={fileListState} />
    ))}
  </Stack>
);

FileListLayout.propTypes = {
  fileListState: FileListStateShape.isRequired,
};
